import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import OnlineUser from "./Left/StarsOnline/OnlineUser";
import OfflineUser from "./Left/StarsOnline/OfflineUser";
import "../../CSS/Sidebar/Left/Left.css";
import "../../CSS/Sidebar/Left/Category.css";
import "../../CSS/Sidebar/Left/Following.css";
import Category from "../../../Assets/Icon/icon/01.png";
import Following from "../../../Assets/Icon/icon/02.png";
import FanGroup from "../../../Assets/Icon/icon/03.png";
import Package from "../../../Assets/Icon/icon/04.png";
import EnrolledAuditions from "../../../Assets/Icon/icon/05.png";
import Activities from "../../../Assets/Icon/icon/06.png";
import Setting from "../../../Assets/Icon/icon/07.png";
import Policy from "../../../Assets/Icon/icon/10.png";
import Sub1 from "../../../Assets/Icon/icon/01s.png";
import Sub2 from "../../../Assets/Icon/icon/02s.png";
import Sub3 from "../../../Assets/Icon/icon/03s.png";
import Sub4 from "../../../Assets/Icon/icon/04s.png";
import Sub5 from "../../../Assets/Icon/icon/05s.png";
import Sub6 from "../../../Assets/Icon/icon/06s.png";
import Sub7 from "../../../Assets/Icon/icon/about-us.jpg";
import {useI18n} from "../../../i18n";

export const LeftSidebar = ({ history, onlineUserProp }) => {
  const [activity, setCountActivity] = useState(0);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [pendingAudition, setPendingAudition] = useState();
  const [fanCount, setFanCount] = useState();
  const [starList, setStarList] = useState([]);

  const [categoryCount, setCategoryCount] = useState();
  const [starCategoryCount, setStarCategoryCount] = useState();
  const [wallet, setWallet] = useState();

  const [spinLeft, setSpinLeft] = useState();

  const cursorStyle = {
    cursor: 'default'
  };
  const { t } = useI18n();

  const getCurrentPlan = async () => {
    const response = await axios.post("/api/loyalty-wallet", {
      action: "current_plan",
    });
    if (response.status === 200) {
      if (response.data.results.wheel_spin_allowed || response.data.results.wheel_spin_count) {
        const left = response.data.results.wheel_spin_allowed - response.data.results.wheel_spin_count;
        setSpinLeft(left);
      }
    }
  };

  useEffect(() => {
    setOnlineUsers(onlineUserProp);

    getCurrentPlan();


    localStorage.getItem("auth_token") &&
      axios.get("api/user/activity_count").then((res) => {
        if (res.data.status === 200) {
          setCountActivity(res.data.activity);
        }
      });

    localStorage.getItem("auth_token") &&
      axios.get("api/user/pendingEnrollAudition").then((res) => {
        if (res.data.status === 200) {
          setPendingAudition(res.data.enrolledAuditionsPending);
        }
      });

    localStorage.getItem("auth_token") &&
      axios.get(`/api/user/fan/group/list`).then((res) => {
        if (res.data.status === 200) {
          setFanCount(res.data.fanCount);
        }
      });

    axios.get(`/api/user/star_list`).then((res) => {
      if (res.data.status === 200) {
        setStarList(res.data.stars);
      }
    });
    axios.get(`/api/all/sidebar/list`).then((res) => {
      if (res.data.status === 200) {
        setCategoryCount(res.data.categoryCount);
        setStarCategoryCount(res.data.starCategoryCount);
        setWallet(res.data.wallet);
      }
    });

    

    //     const [categoryCount, setCategoryCount] = useState();
    // const [starCategoryCount, setStarCategoryCount] = useState();
    //     localStorage.getItem('auth_token') &&
    //         axios.get(`/api/all/sidebar/list`).then((res) => {
    //             if (res.status === 200) {
    //                 setCategoryCount(res.data.categoryCount);
    //                 setStarCategoryCount(res.data.starCategoryCount);
    //             }
    //         });

    // }, []);
  }, [onlineUserProp]);

  const onlineUserArr = onlineUsers.map((item) => parseInt(item.userId));
  // const set = new Set(onlineUserArr);

  const allStarArr = starList.filter(({ id }) => !(onlineUserArr?.includes(id)));

  //assigning location variable
  const location = useLocation();
  const { pathname } = location;
  const url = pathname.split("/");


  return (
    <>
      <div className="MobileLeft left-col-box p-3 mt-3 ">
      <Link to="/about-us">
          <div className="mt-1 ">
            <div
              className={
                url[1] === "about-us" ? "left-side-nav-active" : "left-side-nav"
              }
            >
              <span>
                <img src={Sub7} alt="" className="mx-2  fa-2x" style={{width: "50px", height: "50px", borderRadius: '50%'}} />
              </span>
              <span className="mx-2 left-side-nav-text H-text">
                <span>About Us</span> <br></br>
              </span>
            </div>
          </div>
        </Link>


        <Link to="/category">
          <div className="mt-1 ">
            <div
              className={
                url[1] === "category" ? "left-side-nav-active" : "left-side-nav"
              }
            >
              <span>
                <img src={Category} alt="" className="mx-2  fa-2x" />
              </span>
              <span className="mx-2 left-side-nav-text H-text">
                  {t('Category_Text')}<br />
                <small className="category-size-chat ">
                  {categoryCount ? categoryCount : 0}  {t('Selected_Text')}
                </small>
              </span>
            </div>
          </div>
        </Link>

        <Link to="/following">
          <div className="mt-1 ">
            <div
              className={
                url[1] === "following"
                  ? "left-side-nav-active"
                  : "left-side-nav"
              }
            >
              <span>
                <img src={Following} alt="" className="mx-2  fa-2x" />
              </span>
              <span className="mx-2 left-side-nav-text H-text">
                 {t('Following_Text')} <br />
                <small className="category-size-chat ">
                  {starCategoryCount ? starCategoryCount : 0}  {t('Superstar_Text')}
                </small>
              </span>
            </div>
          </div>
        </Link>

        <Link to="/fan-group">
          <div className="mt-1 ">
            <div
              className={
                url[1] === "fan-group"
                  ? "left-side-nav-active"
                  : "left-side-nav"
              }
            >
              <span>
                <img src={FanGroup} alt="" className="mx-2  fa-2x" />
              </span>
              <span className="mx-2 left-side-nav-text H-text">
                {t('Fan_Group_Text')} <br />
                <small className="category-size-chat ">
                  {fanCount ? fanCount : 0} {t('Group_Text')}
                </small>
              </span>
            </div>
          </div>
        </Link>

        <Link to="/loyalty-wallet">
          <div className="mt-1 ">
            <div
              className={
                url[1] === "loyalty-wallet" ? "left-side-nav-active" : "left-side-nav"
              }
            >
              <span>
                <img src={Package} alt="" className="mx-2  fa-2x" />
              </span>
              <span className="mx-2 left-side-nav-text H-text">
                  {t('Loyalty_Wallet_Text')}<br />
              </span>
            </div>
          </div>
        </Link>

        {/* <Link to="/lucky-spin">
          <div className="mt-1 ">
            <div
              className={
                url[1] === "lucky-spin" ? "left-side-nav-active" : "left-side-nav"
              }
            >
              <span>
                <img src="/spin_icon.png" alt="" className="mx-2  fa-2x" style={{width: "50px"}} />
              </span>
              <span className="mx-2 left-side-nav-text H-text">
                <span>Spin Wheel</span> <br></br>
                <small className="category-size-chat ">{spinLeft} Spin Left</small>
              </span>
            </div>
          </div>
        </Link> */}

        <Link to="/enrolled-auditions">
          <div className="mt-1 ">
            <div
              className={
                url[1] === "enrolled-auditions"
                  ? "left-side-nav-active"
                  : "left-side-nav"
              }
            >
              <span>
                <img src={EnrolledAuditions} alt="" className="mx-2  fa-2x" />
              </span>
              <span className="mx-2 left-side-nav-text H-text">
                 {t('Enrolled_Auditions_Text')}<br />
                <small className="category-size-chat ">
                  {pendingAudition} {" "} {t('Pending_Text')}
                </small>
              </span>
            </div>
          </div>
        </Link>

        <Link to="/activities">
          <div className="mt-1 ">
            <div
              className={
                url[1] === "activities"
                  ? "left-side-nav-active"
                  : "left-side-nav"
              }
            >
              <span>
                <img src={Activities} alt="" className="mx-2  fa-2x" />
              </span>
              <span className="mx-2 left-side-nav-text H-text">
                 {t('Activities_Text')} <br />
                <small className="category-size-chat ">
                  {activity} {t('Activities_recently_Text')}
                </small>
              </span>
            </div>
          </div>
        </Link>

        <Link to="/settings">
          <div className="mt-1 ">
            <div
              className={
                url[1] === "settings" ? "left-side-nav-active" : "left-side-nav"
              }
            >
              <span>
                <img src={Setting} alt="" className="mx-2  fa-2x" />
              </span>
              <span className="mx-2 left-side-nav-text H-text">{t('Settings_Text')}</span>
            </div>
          </div>
        </Link>

        <div className="mt-1 accordion" id="accordionExample">
          <div className="accordion-item bg-dark">
            <h2 className="accordion-header mb-2" id="headingOne">
              <button
                className={
                  url[1] === "about-us" ||
                  url[1] === "privacy-policy" ||
                  url[1] === "product-purchase-flow" ||
                  url[1] === "terms-condition" ||
                  url[1] === "refund-return-policy" ||
                  url[1] === "faq"
                    ? "accordion-button left-side-nav-active"
                    : "accordion-button left-side-nav"
                }
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <span>
                  <img src={Policy} alt="" className="mx-2  fa-2x" />
                </span>
                <span className="mx-2 left-side-nav-text H-text">
                  {t('Terms_Policy_Text')}
                </span>
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse hide "
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div className="px-5 bg-dark border-0">
                <Link
                  to="/about-us"
                  className={`py-2 sub-right-pad mb-2 ${
                    url[1] === "about-us"
                      ? "policy-according-active"
                      : "policy-according"
                  } `}
                >
                  <span>
                    <img src={Sub1} alt="" className="mx-2  fa-2x" />
                  </span>
                  <span className="mx-2 sub-policy H-text">{t('About_Us_Text')}</span>
                </Link>

                <Link
                  to="/privacy-policy"
                  className={`py-2 sub-right-pad mb-2 ${
                    url[1] === "privacy-policy"
                      ? "policy-according-active"
                      : "policy-according"
                  } `}
                >
                  <span>
                    <img src={Sub2} alt="" className="mx-2  fa-2x" />
                  </span>
                  <span className="mx-2 sub-policy H-text">{t('Privacy_Policy_Text')}</span>
                </Link>

                <Link
                  to="/product-purchase-flow"
                  className={`py-2 sub-right-pad mb-2 ${
                    url[1] === "product-purchase-flow"
                      ? "policy-according-active"
                      : "policy-according"
                  } `}
                >
                  <span>
                    <img src={Sub3} alt="" className="mx-2  fa-2x" />
                  </span>
                  <span className="mx-2 sub-policy H-text">
                    {t('Product_Purchase_Flow_Text')}
                  </span>
                </Link>

                <Link
                  to="/terms-condition"
                  className={`py-2 sub-right-pad mb-2 ${
                    url[1] === "terms-condition"
                      ? "policy-according-active"
                      : "policy-according"
                  } `}
                >
                  <span>
                    <img src={Sub4} alt="" className="mx-2  fa-2x" />
                  </span>
                  <span className="mx-2 sub-policy H-text">
                     {t('Terms_Condition_Text')}
                  </span>
                </Link>

                <Link
                  to="/refund-return-policy"
                  className={`py-2 sub-right-pad mb-2 ${
                    url[1] === "refund-return-policy"
                      ? "policy-according-active"
                      : "policy-according"
                  } `}
                >
                  <span>
                    <img src={Sub5} alt="" className="mx-2  fa-2x" />
                  </span>
                  <span className="mx-2 sub-policy H-text">
                    {t('Refund_Return_Policy_Text')}
                  </span>
                </Link>

                {/* <Link
                  to="/faq"
                  className={`py-2 sub-right-pad mb-2 ${
                    url[1] === "faq"
                      ? "policy-according-active"
                      : "policy-according"
                  } `}
                >
                  <span>
                    <img src={Sub6} alt="" className="mx-2  fa-2x" />
                  </span>
                  <span className="mx-2  sub-policy H-text">{t('FAQ_Text')}</span>
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stars Online */}
      <div className="MobileLeft container left-col-box-home-chat chat01 pt-3 mt-3">
        {/*<div className=" mb-2 left-c">*/}
        {/*  <div className="d-flex justify-content-between mts">*/}
        {/*    <div className="">*/}
        {/*      <p className="btn text-success StarOn " style={cursorStyle}>Star Online</p>*/}
        {/*    </div>*/}
        {/*    /!* <div className="">*/}
        {/*      <div className="search-container">*/}
        {/*        <form action="/search" method="get">*/}
        {/*          <input*/}
        {/*            className="searchStar expandright"*/}
        {/*            id="searchright"*/}
        {/*            type="search"*/}
        {/*            name="q"*/}
        {/*            placeholder="Search"*/}
        {/*          />*/}
        {/*          <label*/}
        {/*            className="buttonSr searchbutton"*/}
        {/*            htmlFor="searchright"*/}
        {/*          >*/}
        {/*            <span className="mglass">&#9906;</span>*/}
        {/*          </label>*/}
        {/*        </form>*/}
        {/*      </div>*/}
        {/*    </div> *!/*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>

      <div className="MobileLeft container left-col-box-home-chat-r chat01 px-3 pb-3 pt-1 ">
        <div className="accordion left-c">
          <div className="ScrollStyle">
            <div className="left-bottom-ap-chat">
              {onlineUsers.map((u) => (
                <Link to={`/starprofile/${u.userId}`}>
                  <OnlineUser key={u.userId} user={u.userId} />
                </Link>
              ))}

              {/* Offine User */}
              {allStarArr &&
                allStarArr?.map((u) => <OfflineUser key={u.id} user={u} />)}
            </div>
          </div>
        </div>
      </div>
      {/* Stars Online End*/}
    </>
  );
};
export default LeftSidebar;
